export const POPULAR_MOVIES_REQUEST = 'POPULAR_MOVIES_REQUEST'
export const POPULAR_MOVIES_RESPONSE = 'POPULAR_MOVIES_RESPONSE'
export const POPULAR_MOVIES_QUERY_RESPONSE = 'POPULAR_MOVIES_QUERY_RESPONSE'
export const POPULAR_MOVIES_QUERY_REQUEST = 'POPULAR_MOVIES_QUERY_REQUEST'
